module.exports = "<ui-view></ui-view>"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/categories-faq/categories.html
// module id = 817
// module chunks = 0